import { createFileRoute } from "@tanstack/react-router";
import FederalEmployeeMentalHealthBenefits from "@/pages/FederalEmployeeMentalHealthBenefits";
export const Route = createFileRoute(
  "/federal-employee-mental-health-benefits",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Federal Employee Mental Health Benefits | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Understand your FEHB mental health benefits for TMS, SAINT TMS, and SPRAVATO. Free benefits verification for federal employees in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Federal Employee Mental Health Benefits | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Understand your FEHB mental health benefits for TMS, SAINT TMS, and SPRAVATO. Free benefits verification for federal employees in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/federal-employee-mental-health-benefits",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/federal-employee-mental-health-benefits",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FederalEmployeeMentalHealthBenefits />;
}
